import 'ress';
import 'brand/landing.html';
import { AppWrap } from './app';
import { config } from 'config';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

const root = createRoot(document.querySelector('.root'));
root.render(createElement(AppWrap));

if (module.hot) {
  module.hot.accept('./app', () => {
    console.log('\n'.repeat(40));
    root.render(createElement(AppWrap, { hot: true }));
  });
}
